// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { generateHeaders, createResponseObj } from '..'
import { vcBaseUrl } from '.'


export type ReferralResponse = (SuccessResponse & {
    referral: {
        id: string
        type: string
        action: string
        amount: number
        createdAt: string
        updatedAt: string
        expiresAt: string
        user: {
            id: string
            givenName: string
            familyName: string
        }
    }
}) | FailedResponse

export class GetUserReferralRequest extends Request {
    private constructor(userId: string, init?: RequestInit) { 
        super(`${vcBaseUrl}/user/${userId}/referral`, init) 
    }
    
    static async init(userId: string, init?: RequestInit) {
        return new GetUserReferralRequest(userId, {
            ...init,
            method: 'GET',
            headers: await generateHeaders("Clerk-Token", init?.headers),
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<ReferralResponse> {
        const response = await fetch(this)
        const data = createResponseObj<ReferralResponse>(await response.json())
        console.info("Get User Referral Response:", data)
    
        switch (data.status) {
            case 'successful': return data
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}
